import { defa, T } from 'defa-object';
/**
 * defa.models.Accessory
 * A description.
 * @version 0.1
 */
import Model       from 'scripts/poppet/model';

const Accessory = Model.extend( {
	defaults: {
		id          : null,
		status      : null,
		timestamp   : null,
		temperature : null,
		batteryLevel: null,
		zone        : null,
		deviceType  : null,
		term        : '',
		bId         : '',
		digiHeatMode: null,
		dimplexType : null,
	},
	
	urlRoot: defa.vars.apiHost + '/linkcom//homeAutomation/diyWirelessDevices?attrs=pairedList',
	
	/**
	 * Gets the DateTime in a proper human readable format.
	 * @void
	 */
	getDateTime: function () {
		let date  = new Date(this.get( 'timestamp' ));
		if (this.get( 'timestamp' ) === 946684799000) {
			return
		}
		return date.format( T.dateFormatLong );
	},
	
	/**
	 * Gets the accessory id.
	 * If Nobo device, return bId instead of id.
	 * @string
	 */
	getId: function() {
		if ( this.get('bId') ) {
			return this.get('bId');
		} else {
			return this.get('id');
		}
	},
	
} );

export default Accessory;